import { render, staticRenderFns } from "./BindKeypair.vue?vue&type=template&id=d59aa476&"
import script from "./BindKeypair.vue?vue&type=script&lang=js&"
export * from "./BindKeypair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports